import { Card, AccordionCollapse, FormGroup, FormLabel, FormControl, Stack, Button } from "react-bootstrap";
import { FleetField, SectionProps } from "../Types/calculator";
import { cleanNumberInput, errorStyles, isSectionComplete } from "../Utilities/constants";
import { SectionIndicators } from "./Common";
import { incrementDecrementArrows } from "../Utilities/interface";

export function Fleet(props: SectionProps<FleetField>) {
  const { state, setSettings, onCategorySelected, section } = props
  const { expandedSections, fleetSize, fleetMiles, useMilesPerVehicle } = state

  const complete = isSectionComplete(state, section)
  const validateFleetSize = section.fields["fleetSize"].validationFunction
  const validateFleetMiles = section.fields["fleetMiles"].validationFunction

  return (
    <Card id={section.name}>
      <Card.Header
        tabIndex={50}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onCategorySelected(section.name)}
        as="h3"
        onClick={() => onCategorySelected(section.name)}
      >
        <div style={{ fontWeight: complete ? "lighter" : "inherit" }}>
          {section.name}
        </div>
        <SectionIndicators
          error={!complete && expandedSections.includes(section.name)}
          complete={complete}
          tooltipMessage="The calculator needs to know how many trucks your company is equipping with the technology and how many miles your fleet drives. You can give us your total mileage or per vehicle mileage."
        />
      </Card.Header>
      <AccordionCollapse className="IncludeInExport" eventKey={section.name}>
        <Card.Body>
          <FormGroup>
            <FormLabel aria-label="Fleet Size">
              How many vehicles are you installing the technology on?
              <FormControl
                tabIndex={51}
                value={fleetSize.toLocaleString()}
                min={0}
                type="text"
                style={!validateFleetSize(fleetSize) ? errorStyles : undefined}
                onKeyDown={(ev) => incrementDecrementArrows({ ev, field: "fleetSize", state, setSettings, onlyUpDown: true })}
                onChange={(ev) => setSettings({ fleetSize: cleanNumberInput(ev.target.value) })}
                onBlur={(ev) => setSettings({ fleetSize: cleanNumberInput(ev.target.value) })}
              />
            </FormLabel>
          </FormGroup>
          <FormGroup>
            <FormLabel style={{ width: "100%" }} aria-label="Fleet Miles">
              How many{useMilesPerVehicle ? "" : " total"} International Fuel Tax Agreement (IFTA) miles{" "}
              {useMilesPerVehicle ? "does each vehicle" : "do those vehicles"} drive annually?
              <Stack direction="horizontal" gap={2}>
                <FormControl
                  tabIndex={52}
                  value={fleetMiles.toLocaleString()}
                  min={0}
                  type="text"
                  style={!validateFleetMiles(fleetMiles, state) ? errorStyles : undefined}
                  onChange={(ev) => setSettings({ fleetMiles: cleanNumberInput(ev.target.value) })}
                  onKeyDown={(ev) => incrementDecrementArrows({ ev, field: "fleetMiles", step: 10000, state, setSettings, onlyUpDown: true })}
                  onBlur={(ev) => setSettings({ fleetMiles: cleanNumberInput(ev.target.value) })}
                />
                <Button
                  tabIndex={53}
                  onClick={() => setSettings({ useMilesPerVehicle: !useMilesPerVehicle })}
                  style={{ width: "25rem", maxWidth: undefined }}
                  variant="link"
                >
                  Switch to {useMilesPerVehicle ? "total fleet miles" : "miles per vehicle"}
                </Button>
              </Stack>
            </FormLabel>
          </FormGroup>
        </Card.Body>
      </AccordionCollapse>
    </Card>
  )
}